import http from "./axios_client";
import { apiCaller } from "./metruyenvl_caller";
import { definitions } from "@/services/metruyenvl";

const userAPI = {
    async getInfo(id: string) {
        return apiCaller("/user", "get", { query: { id: id } });
    },
    async updateUser(data?: definitions["do.UserDO"]) {
        return apiCaller("/user", "post", { body: { request: data } });
    },
};

export default userAPI;
